import { ApiService } from '../../services/api_service';
import { lazyInject } from '../../services/inversify';
import { Navigation } from '../../main/Navigation';
import * as React from 'react';
import style from './Sitemap.less';
import { WSpinner } from '../../core/elements/spinner/WSpinner';
export interface SitemapProps {
    data: any;
    onRoutingChange: (routing: any) => void;
}

interface SitemapState extends React.ClassAttributes<any> {
    lastModul: any;
    navigation: any[];
}

export class Sitemap extends React.Component<SitemapProps, SitemapState> {

    constructor(props: any) {
        super(props);
        this.state = {
            lastModul: null,
            navigation: null,
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;

    componentDidMount(): void {
        this.init();
    }

    componentDidUpdate(prevProps: any): void {
        if ((this.props.data || {}).MODUL_SELECTED !== this.state.lastModul) {
            this.init();
        }
    }

    init(): void {
        (new Navigation(this.props.data, this.apiService)).getData((navigation: any) => {
            const lastModul: string = (this.props.data || {}).MODUL_SELECTED;
            this.setState({ lastModul, navigation }, () => console.info('Navigation-INIT:', this.state.navigation));
        });
    }

    render(): JSX.Element {
        return (
            <div className={style.wrapper}>
                <div>
                    {this.renderGroup(this.state.navigation, 0)}
                </div>
                {this.state.navigation === null && <WSpinner />}
            </div>
        );
    }

    renderChildren(item: any, level: number): JSX.Element {
        const isLink: boolean = item.path && !item.children;

        return (
            <div
                className={style[`level-${level}`]}
                style={{
                    color: item.color && item.color, backgroundColor: item.bgcolor && item.bgcolor, cursor: isLink && 'pointer',
                    paddingLeft: level * 20 + 10
                }}
                onClick={() => isLink && this.props.onRoutingChange({ path: item.path || {}, entities: item.entities || [] })}
            >
                {item.name}
            </div>
        );
    }

    renderGroup(data: any[], level: number): JSX.Element[] {
        return (data || []).map((item: any, index: number) => {
            if (item.disabled || false) {
                return null;
            }
            const children: any[] = item.children || [];

            if (level === 0) {
                return (
                    <div
                        key={`group-${index}`}
                        style={{ color: item.color && item.color, backgroundColor: item.bgcolor && item.bgcolor, paddingTop: 5 }}
                    >
                        {this.renderChildren(item, level)}
                        {!!children.length && this.renderGroup(children, level + 1)}
                    </div>
                );
            }

            return (
                <React.Fragment key={`site-${level}-${index}`}>
                    {this.renderChildren(item, level)}
                    {!!children.length && this.renderGroup(children, level + 1)}
                </React.Fragment>
            );
        });
    }
}
